import React from 'react';
import { useProducts } from '../customHooks/useProducts';

/**
 * Custom React Hook to check if the user has any subscription WOHNEN_PLUS | KAEUFER_PLUS | MIETER_PLUS.
 *
 * @returns {boolean} - Returns true if the user has any subscription WOHNEN_PLUS | KAEUFER_PLUS | MIETER_PLUS, false otherwise.
 */
export const useHasMeinPlus = () => {
  const { products } = useProducts();
  return React.useMemo(() => {
    if (!products || !products?.length) return false;
    return true;
  }, [products]);
};
